import { Box, IconButton, Link } from "@mui/material";

import { TimeSince } from "components/DateTime/TimeSince";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { TimeLeft } from "components/DateTime/TimeLeft";
import { ContextMenu } from "components/Menu/ContextMenu";

export const projectListColumnsL = ({
  handleRowClick,
  handleTaskButtonClick,
  handleOpenProducts,
  handleEdit,
  currentUserId,
}) => [
  {
    accessorKey: "docCode",
    header: "Code",
    cell: ({ row }) => (
      <FlexBox justifyContent="space-between">
        <Link
          href="#"
          onClick={() => handleRowClick(row.original)}
          color="textPrimary"
        >
          {row.original.docCode}
        </Link>
      </FlexBox>
    ),
  },
  {
    accessorKey: "clientName",
    header: "Name",
  },
  {
    accessorKey: "clientContactNo",
    header: "Contact",
  },
  {
    accessorKey: "clientEmail",
    header: "Email",
  },
  {
    accessorKey: "projectDeliveryDate",
    header: "Delivery Date",
    cell: ({ row }) => (
      <TimeLeft
        targetDate={row.original.projectDeliveryDate}
        variant="data"
        fontSize={12}
      />
    ),
  },
  {
    accessorKey: "createdBy",
    header: "BDC",
    cell: ({ row }) => (
      <Box whiteSpace={"pre-line"}>
        {row.original.createdBy}
        <br />
        <TimeSince startDate={row.original.createdOn} />
      </Box>
    ),
  },
  { accessorKey: "clientCity", header: "City" },
  {
    accessorKey: "products",
    header: "Products",
    cell: ({ row }) => (
      <>
        <IconButton onClick={() => handleOpenProducts(row.original)}>
          <AddShoppingCartIcon />
        </IconButton>
      </>
    ),
  },
  {
    accessorKey: "action",
    header: "Action",
    cell: ({ row }) => (
      <ContextMenu
        handleEditAction={
          currentUserId === row.original.createdById
            ? () => handleEdit(row.original)
            : null
        }
        editLabel="Update Delivery Date"
        handleTaskAction={() => handleTaskButtonClick(row.original)}
        taskLabel="Create Task"
      />
    ),
  },
];
